import { useAnimation } from "framer-motion";
import React, { useCallback, useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  getClassifieldCatData,
  getClassifieldData,
  getClassifieldPremiumData,
  getLatestClassifieldData,
} from "../../services/HomeServices";
import { toast } from "react-toastify";
import Pagination from "../../containers/Pagination";
import iconStar from "../../assets/images/prime_star.png";
import img from "../../assets/images/azlogomessage.jpeg";
import _ from "lodash";
import { formatDate, minimizeName, plainString } from "../../lib/constant";
import Loader from "../../containers/Loader";
import LatestClassifiedModule from "../../containers/NewDesignModules/LatestClassifiedModule";
import EventDesign from "../NewDesign/EventDesign";

const categoriesEmogiArray = [
  { name: "Art/Dance/Music", emoji: "🎨" }, // Paint palette
  { name: "Automobiles", emoji: "🚘" }, // Car
  { name: "Beauty Services", emoji: "💆" }, // Person getting massage
  { name: "Car Pool", emoji: "🚗" }, // Car
  { name: "Care Takers", emoji: "🧑‍🍼" }, // Person feeding baby
  { name: "Food & Catering", emoji: "🍽️" }, // Plate with utensils
  { name: "For Sale", emoji: "🏷️" }, // Tag
  { name: "Other", emoji: "📢" }, // Megaphone
  { name: "Real Estate", emoji: "🏡" }, // House with garden
  { name: "Rentals", emoji: "🪧" }, // Sign board
  { name: "Training Classes", emoji: "👨‍🏫" }, // Teacher
  { name: "Travel", emoji: "🧳" }, // Luggage
];

const NewDesign = () => {
  const [catData, setcatData] = useState([]);
  const [search, setsearch] = useState("");
  const [latestClassiLoading, setlatestClassiLoading] = useState(false);
  const [latestClassiData, setlatestClassiData] = useState([]);
  const [data, setdata] = useState([]);
  const [toggle, settoggle] = useState(false);
  const [isLoading, setisLoading] = useState(false);
  const [page, setpage] = useState(1);
  const [links, setlinks] = useState([]);
  const [hasAnimatedLeft, setHasAnimatedLeft] = useState(false);
  const params = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    const controller = new AbortController();

    getData(controller?.signal);
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll effect
    });
    return () => {
      controller.abort();
    };
  }, []);

  const controlsLeft = useAnimation();
  const { ref: refLeft, inView: inViewLeft } = useInView({ threshold: 0.1 });

  useEffect(() => {
    if (inViewLeft && !hasAnimatedLeft) {
      controlsLeft.start("visible");
      setHasAnimatedLeft(true); // Set the state to prevent re-triggering
    }
  }, [controlsLeft, inViewLeft]);

  const boxVariantsLeft = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.7 } },
  };

  useEffect(() => {
    const controller = new AbortController();
    classifieldData(params?.id, controller?.signal);
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll effect
    });
    return () => {
      controller.abort();
    };
  }, [page]);

  useEffect(() => {
    const controller = new AbortController();
    const timeout = setTimeout(() => {
      if (toggle) {
        getAllClassifiedData(params?.id || "", controller?.signal);
      } else {
        classifieldData(params?.id || "", controller?.signal);
      }
    }, 1000);
    // classifieldData(params?.id);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
    return () => {
      clearTimeout(timeout);
      controller.abort();
    };
  }, [toggle]);

  useEffect(() => {
    setpage(1);
    const controller = new AbortController();
    const timeout = setTimeout(() => {
      classifieldData(params?.id || "", controller?.signal);
    }, 500);
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Smooth scroll effect
    });
    return () => {
      clearTimeout(timeout);
      controller.abort();
    };
  }, [search, params?.id]);

  const getData = async (signal) => {
    await getClassifieldCatData(signal)
      .then((response) => {
        const array = response?.data?.data?.filter(
          (a) => a?.name !== "Pin Hopes"
        );
        setcatData(array);
        setcatData(response?.data?.data);
      })
      .catch((error) => {
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
          console.log("Aborted");
        } else {
          toast("Something went wrong", { type: "error" });
        }
      });
  };

  const classifieldData = async (id, signal) => {
    setisLoading(true);
    // await getClassifieldData(id || params?.id, search, "", page, 12)
    await getClassifieldPremiumData(page, 12, id || params?.id, search, signal)
      .then((response) => {
        setisLoading(false);
        setdata(response?.data?.data?.data);
        setlinks(response?.data?.data?.links);
      })
      .catch((error) => {
        setisLoading(true);
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
          console.log("Aborted");
        } else {
          toast("Something went wrong", { type: "error" });
        }
      });
  };

  const getAllClassifiedData = async (id, signal) => {
    setisLoading(true);
    await getClassifieldData(id || params?.id, search, "", page, 12, signal)
      //  await getClassifieldPremiumData(page, 12, id || params?.id, search, "")
      .then((response) => {
        setisLoading(false);
        setdata(response?.data?.data?.data);
        setlinks(response?.data?.data?.links);
      })
      .catch((error) => {
        setisLoading(true);
        if (error.name === "CanceledError" || error.code === "ERR_CANCELED") {
          console.log("Aborted");
        } else {
          toast("Something went wrong", { type: "error" });
        }
      });
  };

  return (
    <>
      <div className="container-fluid bg_drackgray">
        <div className="container">
          <div className="row prime_listings">
            <div className="col-6">
              <h2> {!toggle ? "Prime Listings" : "Classified Listings"}</h2>
            </div>
            <div className="col-6">
              {" "}
              <Link to="/classifield-post" className="btn_post">
                Post <i className="fas fa-plus" />
              </Link>{" "}
              <a className="btn_event_cal" onClick={() => settoggle(!toggle)}>
                {!toggle ? "ALL" : "PRIME"}{" "}
              </a>
            </div>
          </div>
          <div className="row classified_sc pt-3">
            <div className="col-sm-6">
              <label>Search Category</label>
            </div>
            <div className="col-sm-3">
              <select
                placeholder="Data"
                className="category"
                value={params?.id}
                onChange={(e) =>
                  e?.target?.value
                    ? navigate(`/classifield/${e?.target?.value}`)
                    : navigate(`/classifieds`)
                }
              >
                <option value="">Select Category</option>
                {catData?.map((x, i) => (
                  <option value={x?.id}>
                    {" "}
                    {categoriesEmogiArray[i]?.emoji}
                    {x?.name}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-sm-3">
              <form
                onSubmit={(e) => {
                  e?.preventDefault();
                  classifieldData(params?.id);
                }}
                className="search_box_01"
              >
                <i className="fa fa-search" aria-hidden="true" />
                <input
                  onChange={(e) => setsearch(e?.target?.value)}
                  value={search}
                  type="text"
                  name="search"
                  placeholder="Search"
                />
              </form>
            </div>
          </div>
          <div className="row pt-4">
            {!isLoading ? (
              <>
                {!_.isEmpty(data) ? (
                  <>
                    {data?.map((x) => (
                      <div
                        className="col-sm-3 pt-4"
                        onClick={() => {
                          navigate(`/classifield-detail/${x?.id}`);
                        }}
                      >
                        <div className="prime_card ">
                          {" "}
                          <img
                            src={iconStar}
                            alt="star"
                            className="prime_star pt-4"
                          />{" "}
                          <img
                            className="card-img-top"
                            style={{ height: "174px", width: "274px" }}
                            src={x?.image || x?.images[0]?.image || img}
                            alt="Card image cap"
                          />
                          <p className="card-text line-clump-2">
                            {minimizeName(plainString(x?.description), 90)}
                          </p>
                          <div className="row">
                            <div className="col-6">
                              <label>
                                <i className="far fa-calendar" />{" "}
                                {formatDate(x?.start_date)}
                              </label>
                            </div>
                            <div className="col-6">
                              <Link to={`/classifield-detail/${x?.id}`}>
                                More
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </>
                ) : (
                  <h5 style={{ textAlign: "center", marginTop: "70px" }}>
                    No Data Found
                  </h5>
                )}
              </>
            ) : (
              <Loader />
            )}
          </div>

          {!_.isEmpty(data) && <Pagination links={links} setpage={setpage} />}
        </div>
      </div>
      <LatestClassifiedModule />
      <EventDesign />
    </>
  );
};

export default NewDesign;
